import React, { useState, useEffect } from 'react';
import { Unlock, PartyPopper } from 'lucide-react';
import './AuthAtmosphere.css';

// Gate-inspired animated background layer for the logged-out landing / auth page
const AuthAtmosphere = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const newParticles = [];
    for (let i = 0; i < 30; i++) {
      newParticles.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 4 + 1,
        duration: Math.random() * 3 + 2,
        delay: Math.random() * 2
      });
    }
    setParticles(newParticles);
  }, []);

  return (
    <div className="auth-atmosphere" data-testid="auth-atmosphere" aria-hidden="true">
      <div className="atmo-gradient-orb atmo-orb-1"></div>
      <div className="atmo-gradient-orb atmo-orb-2"></div>
      <div className="atmo-gradient-orb atmo-orb-3"></div>
      <div className="atmo-grid-overlay"></div>

      {/* Floating Music Notes */}
      <div className="atmo-notes-container">
        {['♪', '♫', '♬', '♩', '𝄞', '♪', '♫', '♬', '♩', '𝄢', '♪', '♫'].map((note, i) => (
          <div
            key={i}
            className="atmo-floating-note"
            style={{
              left: `${5 + (i * 8)}%`,
              animationDelay: `${i * 0.8}s`,
              fontSize: `${16 + (Math.sin(i * 1.5) + 1) * 12}px`,
              animationDuration: `${9 + Math.random() * 4}s`
            }}
          >
            {note}
          </div>
        ))}
      </div>

      {/* Large depth-layer music notes (parallax) */}
      <div className="atmo-notes-container">
        {['♫', '𝄞', '♬', '♪', '♩', '𝄢'].map((note, i) => (
          <div
            key={`big-${i}`}
            className="atmo-floating-note-big"
            style={{
              left: `${8 + i * 16}%`,
              animationDelay: `${i * 2.6}s`,
              fontSize: `${64 + (Math.sin(i * 2) + 1) * 26}px`,
              animationDuration: `${16 + Math.random() * 6}s`
            }}
          >
            {note}
          </div>
        ))}
      </div>

      {/* Floating Particles */}
      <div className="atmo-particles-container">
        {particles.map(p => (
          <div
            key={p.id}
            className="atmo-particle"
            style={{
              left: `${p.x}%`,
              top: `${p.y}%`,
              width: `${p.size}px`,
              height: `${p.size}px`,
              animationDuration: `${p.duration}s`,
              animationDelay: `${p.delay}s`
            }}
          />
        ))}
      </div>

      {/* Scan Lines */}
      <div className="atmo-scan-lines"></div>

      {/* Spinning Vinyl - peeking from the right side */}
      <div className="atmo-vinyl">
        <div className="atmo-vinyl-grooves"></div>
        <div className="atmo-vinyl-label"></div>
        <div className="atmo-vinyl-center"></div>
      </div>

      {/* Sound Wave Bars along the bottom */}
      <div className="atmo-sound-wave">
        {[...Array(70)].map((_, i) => (
          <div
            key={i}
            className="atmo-wave-bar"
            style={{
              animationDelay: `${i * 0.03}s`,
              animationDuration: `${0.6 + Math.sin(i * 0.2) * 0.3}s`
            }}
          />
        ))}
      </div>
    </div>
  );
};

// "ACCESS GRANTED" / "WELCOME TO BEATSEEK" celebration overlay after successful auth
export const AuthCelebration = ({ mode }) => (
  <div className="auth-celebration" data-testid="auth-celebration-overlay">
    <div className="celebration-ring celebration-ring-1"></div>
    <div className="celebration-ring celebration-ring-2"></div>
    <div className="celebration-ring celebration-ring-3"></div>
    <div className="celebration-icon">
      {mode === 'signup' ? <PartyPopper size={64} /> : <Unlock size={64} />}
    </div>
    <div className="celebration-text" data-testid="auth-celebration-text">
      {mode === 'signup' ? 'WELCOME TO BEATSEEK' : 'ACCESS GRANTED'}
    </div>
    <div className="celebration-subtext">
      {mode === 'signup' ? 'Your journey starts now' : 'Welcome back to BEATSEEK'}
    </div>
  </div>
);

export default AuthAtmosphere;
